import { File } from '../types/files';

export const mockFiles: File[] = [
  // Youth Group files
  {
    id: 'file-001',
    filename: 'Image 4-3-25 at 11.17AM.jpeg',
    description: 'Group photo from spring retreat',
    type: 'Photo',
    uploadedBy: 'Mark Anderson',
    uploadedById: '7',
    uploadedByAvatar: '',
    size: '480 KB',
    sizeInBytes: 491520,
    dateUploaded: '2025-04-03T11:17:00Z',
    group: 'Youth Group',
  },
  {
    id: 'file-002',
    filename: 'Group Guidelines.pdf',
    description: 'Community Guidelines and expectations',
    type: 'Document',
    uploadedBy: 'Mark Anderson',
    uploadedById: '7',
    uploadedByAvatar: '',
    size: '225 KB',
    sizeInBytes: 230400,
    dateUploaded: '2025-07-01T14:30:00Z',
    group: 'Youth Group',
  },
  {
    id: 'file-003',
    filename: 'Prayer List - Q1 2025.docx',
    description: 'Ongoing prayer requests for group members',
    type: 'Document',
    uploadedBy: 'Sarah Chen',
    uploadedByAvatar: '',
    size: '1.2 MB',
    sizeInBytes: 1258291,
    dateUploaded: '2025-01-15T09:45:00Z',
    group: 'Youth Group',
  },
  {
    id: 'file-004',
    filename: 'Summer Event Planning.xlsx',
    description: 'Budget and schedule for summer activities',
    type: 'Document',
    uploadedBy: 'Emma Wilson',
    uploadedByAvatar: '',
    size: '45 KB',
    sizeInBytes: 46080,
    dateUploaded: '2024-12-02T16:20:00Z',
    group: 'Youth Group',
  },
  {
    id: 'file-005',
    filename: 'Youth Retreat 2025.jpeg',
    description: 'Promotional flyer for upcoming retreat',
    type: 'Photo',
    uploadedBy: 'John Smith',
    uploadedById: '1',
    uploadedByAvatar: '',
    size: '650 KB',
    sizeInBytes: 665600,
    dateUploaded: '2025-10-15T10:00:00Z',
    group: 'Youth Group',
  },

  // Prayer Group files
  {
    id: 'file-006',
    filename: 'Prayer Points March.pdf',
    description: 'Monthly prayer focus areas',
    type: 'Document',
    uploadedBy: 'Sarah Johnson',
    uploadedByAvatar: '',
    size: '180 KB',
    sizeInBytes: 184320,
    dateUploaded: '2025-03-01T08:00:00Z',
    group: 'Prayer Group',
  },
  {
    id: 'file-007',
    filename: 'Group Photo 2025.jpeg',
    description: 'Annual group photo',
    type: 'Photo',
    uploadedBy: 'David Lee',
    uploadedByAvatar: '',
    size: '920 KB',
    sizeInBytes: 942080,
    dateUploaded: '2025-02-14T12:30:00Z',
    group: 'Prayer Group',
  },
  {
    id: 'file-008',
    filename: 'Prayer Walk Route.pdf',
    description: 'Map and schedule for community prayer walk',
    type: 'Document',
    uploadedBy: 'James Wilson',
    uploadedByAvatar: '',
    size: '340 KB',
    sizeInBytes: 348160,
    dateUploaded: '2025-10-20T15:45:00Z',
    group: 'Prayer Group',
  },

  // Small Group Alpha files
  {
    id: 'file-009',
    filename: 'Study Guide Week 1.pdf',
    description: 'Introduction to the series',
    type: 'Document',
    uploadedBy: 'Michael Chen',
    uploadedByAvatar: '',
    size: '275 KB',
    sizeInBytes: 281600,
    dateUploaded: '2025-09-15T10:00:00Z',
    group: 'Small Group Alpha',
  },
  {
    id: 'file-010',
    filename: 'Potluck Menu Planning.xlsx',
    description: 'Sign-up sheet for dishes',
    type: 'Document',
    uploadedBy: 'Emily Rodriguez',
    uploadedByAvatar: '',
    size: '38 KB',
    sizeInBytes: 38912,
    dateUploaded: '2025-11-01T14:20:00Z',
    group: 'Small Group Alpha',
  },
  {
    id: 'file-011',
    filename: 'Group Outing Photo.jpeg',
    description: 'Fall hiking trip memories',
    type: 'Photo',
    uploadedBy: 'Michael Chen',
    uploadedByAvatar: '',
    size: '1.8 MB',
    sizeInBytes: 1887436,
    dateUploaded: '2025-10-28T17:30:00Z',
    group: 'Small Group Alpha',
  },

  // Other groups
  {
    id: 'file-012',
    filename: 'Worship Team Schedule.pdf',
    description: 'Q4 2025 service assignments',
    type: 'Document',
    uploadedBy: 'Sarah Johnson',
    uploadedByAvatar: '',
    size: '195 KB',
    sizeInBytes: 199680,
    dateUploaded: '2025-09-20T11:00:00Z',
    group: 'Worship Team',
  },
  {
    id: 'file-013',
    filename: 'Easter Service Setup.jpeg',
    description: 'Stage layout and equipment list',
    type: 'Photo',
    uploadedBy: 'Sarah Johnson',
    uploadedByAvatar: '',
    size: '780 KB',
    sizeInBytes: 798720,
    dateUploaded: '2025-03-25T09:15:00Z',
    group: 'Worship Team',
  },
  {
    id: 'file-014',
    filename: 'Children Ministry Curriculum.pdf',
    description: 'Lesson plans for November',
    type: 'Document',
    uploadedBy: 'Amanda Garcia',
    uploadedByAvatar: '',
    size: '520 KB',
    sizeInBytes: 532480,
    dateUploaded: '2025-10-30T13:45:00Z',
    group: 'Children\'s Ministry',
  },
  {
    id: 'file-015',
    filename: 'VBS 2025 Theme.jpeg',
    description: 'Artwork and branding materials',
    type: 'Photo',
    uploadedBy: 'Amanda Garcia',
    uploadedByAvatar: '',
    size: '1.1 MB',
    sizeInBytes: 1153433,
    dateUploaded: '2025-05-10T10:30:00Z',
    group: 'Children\'s Ministry',
  },
];
